/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Breadcrumb, Button, Col, Dropdown, Form, Modal, NavItem, NavLink, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { usePageTitle } from '../../../../../App';
import check_yellow_icon from '../../../../../assets/images/check-yellow-icon.svg';
import star_icon from '../../../../../assets/images/red-star-icon.svg';
import FAQ from '../../../../../assets/pdf/FAQ.pdf';
import { CustomTable, CustomTooltips } from '../../../../../components';
import { ALL_FILE_ROUTE, DASHBOARD_ROUTE } from '../../../../../constants/RouteNameConstants';
import { myFilesDashboardProofreaderTableData, myStatsTableData } from '../../../../../constants/TableHeaderConstants';
import { legalCategoryTemplate } from '../../../../../utils/TableCellUtils';
import { truncateString } from '../../../../../utils/TruncateStringUtils';
import { getUserInfo } from '../../../../../utils/UserInfoUtils';
import { myMetricsRequest, resetMyMetricsData } from '../../../MyMetrics/actions';
import RatingMetrics from '../../../MyMetrics/component/RatingMetrics';
import { proofreaderFilesFilterRequest } from '../../AllFiles/actions';
import { proofreaderMyFilesRequest } from '../actions';
import moment from 'moment';
import { getDaysDiff } from '../../AllFiles/component/AllFiles';
import StatusDropdown from './StatusDropdown';
import { Badge } from '@mui/material';
import toast from 'react-hot-toast';
import { trackEvent } from '../../../../../utils/ga';

const MyFiles = ({
  dueInHalfDayClick = false,
  filterClientData,
  setFilterClientData,
  filterVendorData,
  setFilterVendorData,
  filterLanguageData,
  setFilterLanguageData,
  filterServiceData,
  setFilterServiceData,
  handleFilter,
  handleFilterClear,
  setProofReaderAllFileFilterModal,
  proofReaderAllFileFilterModal,
  filterApiCall,
  setFilterApiCall,
  currentPage,
  setCurrentPage,
  setClaimFile,
  setFilterFilesStatusData,
  filterFilesStatusData,
  isFilterApplied,
}) => {
  usePageTitle('Datagain Transcription  - Files > My Files'); // Set tab title

  const dispatch = useDispatch();
  const userInfo = getUserInfo();
  const navigate = useNavigate();
  const debounceTimer = useRef(null);
  const [searchValue, setSearchValue] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortField, setSortField] = useState('DueIn');
  const [sortOrder, setSortOrder] = useState(0);
  const [proofReaderMyFileMetricsModal, setProofReaderMyFileMetricsModal] = useState(false);

  // Use useLocation hook to listen for route changes
  const location = useLocation();

  // Reset states whenever the route changes
  useEffect(() => {
    setSearchValue('');
    setRowsPerPage(10);
    setCurrentPage(0);
    setSortField('DueIn');
    setSortOrder(0);
    setProofReaderAllFileFilterModal(false);
    setFilterApiCall(false);
    setFilterClientData('');
    setFilterVendorData('');
    setFilterLanguageData('');
    setFilterServiceData('');
    setProofReaderMyFileMetricsModal(false);
  }, [location]); // This effect runs every time the location (route) changes

  // My file's Data
  let proofreaderFileFilterList = useSelector((state) => state?.proofreaderFilesFilterList?.user?.data?.value);

  let proofreaderMyFileList = useSelector((state) => state?.proofreaderMyFilesList?.user?.data?.value);

  let filterDataFile = proofreaderFileFilterList && JSON.parse(proofreaderFileFilterList);

  let proofreaderMyFileTable = proofreaderMyFileList && JSON.parse(proofreaderMyFileList);

  // Api's loading
  const loading = useSelector((state) => state?.proofreaderMyFilesList?.loading);

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchValue(value);

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      setCurrentPage(0);
      setFilterApiCall(true);
      if (value)
        trackEvent('file_search', {
          query: value,
          page: 'my_files',
        });
    }, 2000);
  };

  // Table data sorting function
  const handleSortChange = (event) => {
    setSortField(event.sortField);
    setSortOrder(event.sortOrder);
    setCurrentPage(0);
    setFilterApiCall(true);
  };

  useEffect(() => {
    if (filterApiCall) {
      var params = {
        page: currentPage + 1,
        rowNumber: rowsPerPage,
        sortRowName: sortField,
        sortRowDirection: sortOrder === 1 ? 'asc' : 'desc',
        search: searchValue,
        isFullQC: false,
        isQC: false,
        isLegal: false,
        isDueInaDay: false,
        isDueInaHalfDay: dueInHalfDayClick,
        filter: {
          clientId: filterClientData === '' ? null : filterClientData,
          serviceType: filterServiceData,
          userId: userInfo?.UserId,
          vendorId: filterVendorData === '' ? null : filterVendorData,
          language: filterLanguageData,
          status: filterFilesStatusData?.length > 0 ? filterFilesStatusData : [],
        },
      };
      dispatch(proofreaderMyFilesRequest(params));
      setFilterApiCall(false);
    }
  }, [dispatch, currentPage, rowsPerPage, sortField, sortOrder, dueInHalfDayClick, searchValue, filterApiCall]);

  useEffect(() => {
    dispatch(
      proofreaderFilesFilterRequest({
        UserId: userInfo?.UserId,
        isMyFiles: true,
      }),
    );
    setFilterApiCall(false);
  }, [dispatch]);

  const handleShowProofReaderMyFileFilter = () => {
    setProofReaderAllFileFilterModal(true);
  };

  const handleCloseProofReaderMyFileFilter = () => {
    setProofReaderAllFileFilterModal(false);
  };

  const handleOpenProofReaderMyFileMetrics = (id) => {
    dispatch(resetMyMetricsData());
    if (id) {
      setProofReaderMyFileMetricsModal(true);
      dispatch(myMetricsRequest(id));
    }
  };

  const handleCopyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success('Copied to clipboard');
      })
      .catch((err) => {
        toast.error('Failed to copy to clipboard');
      });
  };

  const clientNameTemplate = (rowData, { isRowHovered }) => {
    return (
      <div className="d-flex align-items-center" style={{ position: 'relative', userSelect: 'text' }}>
        <span>{rowData?.ClientName}</span>
        {rowData?.ClientName !== ' ' && (
          <div style={{ width: '24px', height: '24px', flexShrink: 0, marginLeft: '8px' }}>
            <CustomTooltips title="Copy to clipboard" placement="top">
              <ContentCopyIcon
                style={{
                  fontSize: '16px',
                  color: '#1285df',
                  cursor: 'pointer',
                  visibility: isRowHovered && rowData?.ClientName ? 'visible' : 'hidden',
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  console.log(rowData);
                  handleCopyToClipboard(rowData?.ClientName);
                }}
              />
            </CustomTooltips>
          </div>
        )}
      </div>
    );
  };

  // Custom body template for file name on column
  const ProofreaderMyFilesTemplate = (rowData, { isRowHovered }) => {
    const [showFullName, setFullName] = useState(false);

    const isCompleted = rowData?.Status.toLowerCase() === 'completed';

    const handleClick = (e) => {
      e.stopPropagation();
      const selection = window.getSelection();
      if (selection && selection.toString().length > 0) return;

      if (!isCompleted && rowData?.Id !== null && rowData?.Id !== undefined) {
        setClaimFile(false);
        trackEvent('file_resume', {
          file_id: rowData?.Id,
          file_name: rowData?.UserFileName,
        });
        navigate(
          rowData?.Id ? `/${window.endPoint.IS_SLATE ? 'editor-copy' : 'editor'}/${rowData?.Id}` : DASHBOARD_ROUTE,
        );
      }
    };

    return (
      <div
        className="d-flex align-items-center"
        style={{ width: '310px', whiteSpace: 'normal', wordBreak: 'break-word' }}
        onMouseEnter={() => setFullName(true)}
        onMouseLeave={() => setFullName(false)}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <Dropdown as={NavItem} className="position-static">
          <Dropdown.Toggle as={NavLink} className="nav-user">
            <span className="table-folder-icon">
              <FolderOutlinedIcon className="fnt-20" />
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu className="file-toggle-box">
            <div className="file-info-header">
              <h6 className="fnt-16 fw-semibold mb-0">File Information</h6>
            </div>
            <ul className="file-list-ul">
              {rowData?.VendorLevel && (
                <li>
                  Vendor Level <span className="file-list-content">: {rowData?.VendorLevel}</span>
                </li>
              )}
              {rowData?.AudioLanguage && (
                <li>
                  Audio Language <span className="file-list-content">: {rowData?.AudioLanguage}</span>
                </li>
              )}
              {rowData?.Originalvendorname && (
                <li>
                  Original Vendor <span className="file-list-content">: {rowData?.Originalvendorname}</span>
                </li>
              )}
            </ul>
          </Dropdown.Menu>
        </Dropdown>
        <div className={`table-link ${isCompleted ? '' : 'cursor-pointer'}`} onClick={handleClick}>
          <CustomTooltips title={rowData?.UserFileName} placement="bottom" className="cursor-auto">
            <span
              style={{
                userSelect: 'text',
                color: isCompleted ? 'black' : '',
                cursor: isCompleted ? 'default' : 'pointer',
              }}
              title={rowData?.UserFileName}
            >
              {showFullName ? rowData?.UserFileName : truncateString(rowData?.UserFileName, 25)}
            </span>
          </CustomTooltips>{' '}
          <CustomTooltips title="Copy to clipboard" placement="top">
            <ContentCopyIcon
              style={{
                fontSize: '16px',
                color: '#1285df',
                cursor: 'pointer',
                visibility: isRowHovered && rowData?.ClientName ? 'visible' : 'hidden',
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleCopyToClipboard(rowData?.UserFileName);
              }}
            />
          </CustomTooltips>
          {rowData?.isLegal && <img src={star_icon} alt="legal" />}
          {rowData?.IsFullQC && <img src={check_yellow_icon} alt="QC" />}
        </div>
      </div>
    );
  };

  const vendorNameTemplate = (rowData, { isRowHovered }) => {
    return (
      <div className="d-flex align-items-center" style={{ position: 'relative', userSelect: 'text' }}>
        <div
          style={{ color: '#1285df', cursor: 'pointer' }}
          onClick={() => handleOpenProofReaderMyFileMetrics(rowData?.VendorId)}
        >
          {rowData?.VendorName}
        </div>
        {rowData?.VendorName !== ' ' && (
          <div style={{ width: '24px', height: '24px', flexShrink: 0, marginLeft: '8px' }}>
            <CustomTooltips title="Copy to clipboard" placement="top">
              <ContentCopyIcon
                style={{
                  fontSize: '16px',
                  color: '#1285df',
                  cursor: 'pointer',
                  visibility: isRowHovered && rowData?.VendorName ? 'visible' : 'hidden',
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleCopyToClipboard(rowData?.VendorName);
                }}
              />
            </CustomTooltips>
          </div>
        )}
      </div>
    );
  };

  // Custom body template for Vendor CompanyName on column
  const companyNameTemplate = (rowData) => {
    return <>{rowData?.CompanyName ? <div>{rowData?.CompanyName}</div> : <div>--</div>}</>;
  };

  const additionalOptionsTemplate = (rowData) => {
    const options = [];

    if (rowData.VerbatimTranscription) options.push('Verbatim');
    if (rowData.Timestamps) options.push('Timestamp');
    if (rowData.PII) options.push('Redact');

    return <>{options.length ? <p>{options.join(', ')}</p> : <div>--</div>}</>;
  };

  const projectManagerTemplate = (rowData) => {
    return <>{rowData?.ProjectManager ? <div>{rowData?.ProjectManager}</div> : <div>--</div>}</>;
  };

  const dueInTemplate = (rowData) => {
    const dueDate = rowData?.DueDate;
    const formattedDate = moment(dueDate).format('MM/DD/YYYY');
    const formatDiff = () => {
      const diff = getDaysDiff(dueDate);
      if (diff === 0) return 'Today';
      else if (diff > 0) return 'In ' + diff + ' days';
      else if (diff < 0) return Math.abs(diff) + ' days ago';
    };
    return (
      <div
        style={{
          color: getDaysDiff(dueDate) < 0 ? '#ef3131' : 'unset',
          fontWeight: getDaysDiff(dueDate) === 0 ? 600 : 400,
        }}
      >
        {formatDiff()} ({formattedDate})
      </div>
    );
  };

  const statusTemplate = (rowData) => {
    const statusColors = {
      Rework: '#b76e00',
      Claimed: '#d92d20',
      ProofReading: '#316ea0',
      Proofreading: '#316ea0',
      Review: '#1a7f5a',
      Failed: '#9b0000',
      Submitted: '#5c6f00',
      InProgress: '#6b32ca',
      Uploaded: '#002855',
      Processing: '#5c4a75',
      Completed: '#47590a',
    };

    const color = statusColors[rowData?.Status];
    return <span style={{ color }}>{rowData?.Status}</span>;
  };

  // Modification table cell
  const bodyTemplates = {
    UserFileName: ProofreaderMyFilesTemplate,
    VendorName: vendorNameTemplate,
    ClientName: clientNameTemplate,
    CompanyName: companyNameTemplate,
    LegalCategory: legalCategoryTemplate,
    DueIn: dueInTemplate,
    Status: statusTemplate,
    AdditionalOptions: additionalOptionsTemplate,
    ProjectManager: projectManagerTemplate,
  };

  let loadingMetrics = useSelector((state) => state?.myMetrics?.loading);

  let myMetricsDataTable = useSelector((state) => state?.myMetrics?.user?.data?.value);

  let myMetrics = myMetricsDataTable && JSON.parse(myMetricsDataTable)?.MyMetrics;

  let ratingMetrics = myMetricsDataTable && JSON.parse(myMetricsDataTable)?.RatingMetrics;

  const selectStyles = {
    control: (base) => ({
      ...base,
      height: '50px',
      minWidth: '200px',
      border: '1px solid #e6e6e6',
      borderRadius: '4px',
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999, // Ensure the dropdown is above the modal
    }),
  };

  return (
    <span>
      <Row>
        <Col className="d-flex align-items-center">
          <div className="mainTitle">
            <Breadcrumb>
              <Breadcrumb.Item>
                <span onClick={() => navigate(ALL_FILE_ROUTE)}>All Files</span> <NavigateNextIcon />
                {dueInHalfDayClick ? 'Due in 12Hrs Files' : 'My Files'}
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </Col>
        <Col md="auto" className="d-flex align-items-center mb-3 gap-3">
          <Form className="search-group main-search-group">
            <Form.Group className="search-group" controlId="exampleForm.ControlInput1">
              <Form.Control
                className="border-0"
                type="text"
                placeholder="Search"
                onChange={handleSearch}
                onKeyDown={(e) => {
                  if (e.keyCode === 13 || e.key === 'Enter') {
                    e.preventDefault();
                  }
                }}
                autoComplete="off"
              />
              <span>
                <SearchRoundedIcon />
              </span>
            </Form.Group>
          </Form>
          <button
            className="filter-btn cursor-pointer"
            onClick={handleShowProofReaderMyFileFilter}
            style={{ background: 'transparent' }}
          >
            <Badge color="primary" variant="dot" invisible={!isFilterApplied}>
              <TuneRoundedIcon />
            </Badge>
          </button>
        </Col>
      </Row>
      <Row>
        <Col xs="12" style={{ marginBottom: 50 }}>
          <div className="card-widget">
            <CustomTable
              tableData={myFilesDashboardProofreaderTableData}
              filteredCustomers={proofreaderMyFileTable ? proofreaderMyFileTable?.Files : []}
              totalRecords={proofreaderMyFileTable?.NoOfRecords}
              rowsPerPage={rowsPerPage}
              sortOrder={sortOrder}
              sortField={sortField}
              setRowsPerPage={setRowsPerPage}
              handleSortChange={handleSortChange}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setFilterApiCall={setFilterApiCall}
              loading={loading}
              checkbox={false}
              bodyTemplates={bodyTemplates}
              pageName="Dashsboard"
            />
          </div>
        </Col>
      </Row>
      <Modal
        show={proofReaderAllFileFilterModal}
        onHide={handleCloseProofReaderMyFileFilter}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="custom-modal"
      >
        <div>
          <div className="preview-dropdown-header">
            Filter By
            <HighlightOffRoundedIcon
              onClick={handleCloseProofReaderMyFileFilter}
              className="cursor-pointer opacity-50"
              style={{ height: '28px', width: '28px' }}
            />
          </div>
          <div className="preview-dropdown-body">
            <Row>
              <Col md="6" className="mb-3">
                <label>Client</label>
                <Select
                  value={
                    filterClientData
                      ? {
                        value: filterClientData,
                        label: filterDataFile?.UserList.find((option) => option.Id === filterClientData)?.Name,
                      }
                      : { value: '', label: 'Show All' }
                  }
                  onChange={(selectedOption) => setFilterClientData(selectedOption ? selectedOption.value : '')}
                  options={[
                    { value: '', label: 'Show All' },
                    ...(filterDataFile?.UserList.map((option) => ({
                      value: option.Id,
                      label: option.Name,
                    })) || []),
                  ]}
                  isSearchable
                  placeholder="Select Client"
                  styles={selectStyles}
                  classNamePrefix="custom-select"
                  menuPortalTarget={document.body} // Render dropdown outside the modal
                />
              </Col>

              <Col md="6" className="mb-3">
                <label>Vendor</label>
                <Select
                  value={
                    filterVendorData
                      ? {
                        value: filterVendorData,
                        label: filterDataFile?.VendorList.find((option) => option.Id === filterVendorData)?.Name,
                      }
                      : { value: '', label: 'Show All' }
                  }
                  onChange={(selectedOption) => setFilterVendorData(selectedOption ? selectedOption.value : '')}
                  options={[
                    { value: '', label: 'Show All' },
                    ...(filterDataFile?.VendorList.map((option) => ({
                      value: option.Id,
                      label: option.Name,
                    })) || []),
                  ]}
                  isSearchable
                  placeholder="Select Vendor"
                  styles={selectStyles}
                  classNamePrefix="custom-select"
                  menuPortalTarget={document.body} // Render dropdown outside the modal
                />
              </Col>

              <Col md="6" className="mb-3">
                <label>Language</label>
                <Select
                  value={
                    filterLanguageData
                      ? {
                        value: filterLanguageData,
                        label: filterDataFile?.LanguageList.find((option) => option.Name === filterLanguageData)
                          ?.Name,
                      }
                      : { value: '', label: 'Show All' }
                  }
                  onChange={(selectedOption) => setFilterLanguageData(selectedOption ? selectedOption.value : '')}
                  options={[
                    { value: '', label: 'Show All' },
                    ...(filterDataFile?.LanguageList.map((option) => ({
                      value: option.Name,
                      label: option.Name,
                    })) || []),
                  ]}
                  isSearchable
                  placeholder="Select Language"
                  styles={selectStyles}
                  classNamePrefix="custom-select"
                  menuPortalTarget={document.body} // Render dropdown outside the modal
                />
              </Col>
              <Col md="6" className="mb-3">
                <label>Service</label>
                <Form.Select
                  aria-label="Default select example"
                  value={filterServiceData}
                  onChange={(e) => setFilterServiceData(e.target.value)}
                >
                  <option value="">Select Service</option>
                  {filterDataFile &&
                    filterDataFile?.ServiceList.map((option, index) => (
                      <option key={index} value={option.Id}>
                        {option.Name}
                      </option>
                    ))}
                </Form.Select>
              </Col>
              <Col md="6" className="mb-3">
                <StatusDropdown
                  filterFilesStatusData={filterFilesStatusData}
                  setFilterFilesStatusData={setFilterFilesStatusData}
                  isShowCompleted={true}
                />
              </Col>
              <Col md="12" className="text-end mt-5">
                <Button
                  variant="outline-secondary"
                  onClick={handleFilterClear}
                  className="me-2"
                  style={{ height: '45.49px', fontWeight: 600 }}
                >
                  Clear Filter
                </Button>
                <Button
                  variant="primary"
                  onClick={() => {
                    trackEvent('file_filter', {
                      page: 'my_files',
                      client: filterClientData,
                      vendor: filterVendorData,
                      language: filterLanguageData,
                      service: filterServiceData,
                    });
                    handleFilter();
                  }}
                  className="ms-2"
                  style={{ height: '45.49px', fontWeight: 600 }}
                >
                  Filter
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </Modal>
      <Modal
        show={proofReaderMyFileMetricsModal}
        onHide={() => setProofReaderMyFileMetricsModal(false)}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="custom-modal"
      >
        <div>
          <div className="preview-dropdown-header">
            Metrics
            <HighlightOffRoundedIcon
              onClick={() => setProofReaderMyFileMetricsModal(false)}
              className="cursor-pointer opacity-50"
              style={{ height: '28px', width: '28px' }}
            />
          </div>
          <div className="preview-dropdown-body">
            <div
              className="text-end"
              onClick={() => window.open(FAQ, '_blank')}
              style={{
                textDecoration: 'underline',
                color: '#190041',
                cursor: 'pointer',
                marginBottom: '6px',
              }}
            >
              FAQ
            </div>
            <div className="mb-4">
              <div className="card-widget">
                <CustomTable
                  tableData={myStatsTableData}
                  filteredCustomers={myMetrics ? myMetrics : []}
                  loading={loadingMetrics}
                  checkbox={false}
                  pagination={false}
                />
              </div>
            </div>
            <div className="mb-3">
              <div className="card-widget">
                <RatingMetrics loading={loading} ratingMetrics={ratingMetrics} />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </span>
  );
};

export default MyFiles;
